import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useIsLoadingResources } from "@lib/context/shared/loading-resources-context";
import { resetScrollPos } from "@lib/util/scroll-ops";
import { useSearchParams } from "next/navigation";
import { useRouter, usePathname } from "navigation";
import { useActiveContent } from "@lib/context/shared/active-content-context";
import { DEFAULT_APP, PRODUCTS_LIST } from "@lib/constants";
const defaultPushOptions = {
  tag: undefined
};
const useMuscleRouter = () => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const showRetail = process.env.NEXT_PUBLIC_SHOW_RETAIL === "true";
  const showFlights = process.env.NEXT_PUBLIC_SHOW_FLIGHTS === "true";
  const showCars = process.env.NEXT_PUBLIC_SHOW_CARS === "true";
  const showHotels = process.env.NEXT_PUBLIC_SHOW_HOTELS === "true";
  const showMillasBenefit = process.env.NEXT_PUBLIC_SHOW_MILLASBENEFIT === "true";
  const offChangeProduct = process.env.NEXT_PUBLIC_OFF_SELECT_PRODUCT === "true";
  const {
    setIsLoadingPage
  } = useIsLoadingResources();
  const {
    setActiveContentToDefault
  } = useActiveContent();
  const goHome = () => {
    var _process$env$NEXT_PUB, _localStorage$getItem;
    const defaultApp = (_process$env$NEXT_PUB = process.env.NEXT_PUBLIC_DEFAULT_APP) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : DEFAULT_APP;
    const actualApp = (_localStorage$getItem = localStorage.getItem("current-app")) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : defaultApp;
    router.replace("/" + actualApp);
  };
  const push = function (route, params) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultPushOptions;
    let omitLoadingPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let pushUrl = "".concat(route).concat(params ? "?".concat(getSearchQueryParamsStringFromObject(params)) : "").concat(options.tag ? "#".concat(options.tag) : "");
    if (route.split("?")[0] !== pathname.split("?")[0]) {
      if (!omitLoadingPage) {
        setIsLoadingPage(true);
      }
      setActiveContentToDefault("router");
    }
    router.push(pushUrl);
  };
  const back = () => {
    setIsLoadingPage(true);
    resetScrollPos();
    router.back();
  };
  const isHome = () => {
    const splitPathname = pathname.split("/");
    if (splitPathname.length > 2) {
      return false;
    }
    switch (splitPathname[1]) {
      case "hotels":
      case "cars":
      case "flights":
      case "millasbenefit":
        return true;
      default:
        return false;
    }
  };
  const isConfirmation = () => {
    return pathname.includes("/flights/checkout/confirmation") || pathname.includes("hotels/confirmation") || pathname.includes("/cars/checkout/success");
  };
  const isLanding = () => {
    const splitPathname = pathname.split("/").filter(segment => segment !== "");
    return splitPathname.length <= 1 && !isHome();
  };
  const isMillasBenefit = () => {
    return pathname.includes("/millasbenefit");
  };
  const setQueryParam = (key, value) => {
    let paramsObject = getSearchQueryParamsObject();
    paramsObject[key] = value;
    push(pathname, paramsObject);
  };
  const setMultipleQueryParams = params => {
    let paramsObject = getSearchQueryParamsObject();
    paramsObject = _objectSpread(_objectSpread({}, paramsObject), params);
    push(pathname, paramsObject);
  };
  const getQueryParam = key => {
    return searchParams.get(key);
  };
  const removeQueryParam = key => {
    let paramsObject = getSearchQueryParamsObject();
    delete paramsObject[key];
    push(pathname, paramsObject);
  };
  const removeMultipleQueryParams = keys => {
    let paramsObject = getSearchQueryParamsObject();
    keys.forEach(key => {
      delete paramsObject[key];
    });
    push(pathname, paramsObject);
  };
  const getSearchQueryParamsObject = () => {
    let paramsObject = {};
    let paramsArray = Array.from(searchParams.entries());
    paramsArray.forEach(param => {
      paramsObject[param[0]] = param[1];
    });
    return paramsObject;
  };
  const getSearchQueryParamsStringFromObject = paramsObject => {
    let paramsString = "";
    const paramsArray = Object.keys(paramsObject).map(key => {
      return "".concat(key, "=").concat(paramsObject[key]);
    });
    paramsArray.forEach((param, index) => {
      paramsString += "".concat(param).concat(index < paramsArray.length - 1 ? "&" : "");
    });
    return paramsString;
  };
  const prefetch = route => {
    router.prefetch(route);
  };
  const replace = (route, params) => {
    let pushUrl = "".concat(route).concat(params ? "?".concat(getSearchQueryParamsStringFromObject(params)) : "");
    router.replace(pushUrl);
  };
  const getActiveProductsCount = () => {
    return [showFlights, showCars, showHotels, showMillasBenefit, showRetail].filter(Boolean).length;
  };
  const getCheckIsActiveProduct = app => {
    switch (app) {
      case PRODUCTS_LIST.FLIGHTS:
        return showFlights;
      case PRODUCTS_LIST.HOTELS:
        return showHotels;
      case PRODUCTS_LIST.CARS:
        return showCars;
      case PRODUCTS_LIST.MILLASBENEFIT:
        return showMillasBenefit;
    }
    return false;
  };
  const getCheckIsActiveProductMaintenance = app => {
    switch (app) {
      case PRODUCTS_LIST.FLIGHTS:
        return process.env.NEXT_PUBLIC_SHOW_FLIGHTS_MAINTENANCE === "false";
      case PRODUCTS_LIST.HOTELS:
        return process.env.NEXT_PUBLIC_SHOW_HOTELS_MAINTENANCE === "false";
      case PRODUCTS_LIST.CARS:
        return process.env.NEXT_PUBLIC_SHOW_CARS_MAINTENANCE === "false";
    }
    return false;
  };
  const isChangeProductActive = () => {
    return !offChangeProduct && getActiveProductsCount() > 1;
  };
  const getIsMapPresent = () => {
    return getQueryParam("mapPresent") === "true";
  };
  return {
    push,
    back,
    setQueryParam,
    getQueryParam,
    removeQueryParam,
    setMultipleQueryParams,
    removeMultipleQueryParams,
    isHome,
    prefetch,
    replace,
    goHome,
    isLanding,
    getActiveProductsCount,
    getCheckIsActiveProduct,
    isChangeProductActive,
    getCheckIsActiveProductMaintenance,
    isConfirmation,
    getIsMapPresent,
    isMillasBenefit
  };
};
export default useMuscleRouter;